import { ReactElement, useState } from 'react'
import { FormattedMessage } from 'react-intl'
import { useMutation, useApolloClient } from '@apollo/client'

import Dropdown from 'components/v2/Dropdown'
import List from 'components/v2/List'
import { DotsIcon } from 'components/Icons/DotsIcon'
import { ActivateAction } from 'components/ActivateAction'
import IconButton from 'components/v2/IconButton'
import { DEACTIVATE_COUPON } from 'features/Campaigns/mutations-legacy'
import {
  resolvers as couponsResolvers,
  ACTIVATE_LOCAL_COUPON,
  ACTIVATE_COUPON,
  DEACTIVATE_LOCAL_COUPON
} from 'resolvers/coupons'
import { GTCoupon } from 'gql/types.generated'

export const CouponsActions = ({ coupon }: { coupon: GTCoupon }): ReactElement => {
  const client = useApolloClient()
  client.addResolvers(couponsResolvers)
  const [isOpenDropdown, setOpenDropdown] = useState(false)

  const toggleDropdown = (): TSFixMe => {
    setOpenDropdown(!isOpenDropdown)
  }

  const [activateLocalCoupon] = useMutation(ACTIVATE_LOCAL_COUPON)
  const [activateCoupon, { loading: activateLoading, error: activateError }] = useMutation(ACTIVATE_COUPON, {
    onCompleted() {
      activateLocalCoupon({
        variables: {
          id: coupon.id
        }
      })
    }
  })
  const [deactivateLocalCoupon] = useMutation(DEACTIVATE_LOCAL_COUPON)
  const [deactivateCoupon, { loading: deactivateLoading, error: deactivateError }] = useMutation(DEACTIVATE_COUPON, {
    onCompleted() {
      deactivateLocalCoupon({
        variables: {
          id: coupon.id
        }
      })
    }
  })

  const toggleCouponActivation = (): void => {
    if (coupon.isActive) {
      deactivateCoupon({
        variables: {
          campaignId: coupon.campaign.id,
          couponId: coupon.id
        }
      })
    } else {
      activateCoupon({
        variables: {
          campaignId: coupon.campaign.id,
          couponId: coupon.id
        }
      })
    }
  }

  return (
    <>
      <Dropdown.Wrapper noPadding noIndicator onClickAway={(): void => setOpenDropdown(false)}>
        <IconButton icon={<DotsIcon />} onClick={toggleDropdown} noBorder smallPadding />
        <Dropdown.Content open={isOpenDropdown} noIndicator left>
          <List.Container>
            <List.Item noPadding>
              <List.Link to={`/coupons/${coupon.id}`}>
                <FormattedMessage id="coupons.list.actions.edit" defaultMessage="Edit" />
              </List.Link>
            </List.Item>
            <List.Item action onClick={toggleCouponActivation} loading={activateLoading || deactivateLoading}>
              <ActivateAction isActive={coupon.isActive} error={deactivateError || activateError} />
            </List.Item>
          </List.Container>
        </Dropdown.Content>
      </Dropdown.Wrapper>
    </>
  )
}
